import React, { useEffect, useState } from "react"
import AsyncSelect from 'react-select/async';
import { fetchCities, fetchNearestCity } from "../../services/api/influencer";
import { debounce } from "lodash";
import { Coordinates } from "../../types/address";
import Select from 'react-select'
import { useLocationAccess } from "../../contexts/LocationContext";
import { Link } from "react-router-dom";
import { detectBrowser } from "../../utils/detectBrowser";
import { isNativePlatform } from "../../utils/platformUtil";
interface LocationSelectionProps {
    value: string,
    onChange: (selected: string) => void,
    updateCoordinates: (coords: Coordinates | null) => void,
    onMenuOpen: () => void,
    onMenuClose: () => void,
}

const LocationSelection: React.FC<LocationSelectionProps> = ({ value, onChange, updateCoordinates, onMenuOpen, onMenuClose }) => {

    const [coordinates, setCoordinates] = useState<Coordinates | null>(null);
    const [nearbyCities, setNearbyCities] = useState<{ label: string, value: string }[]>([]);
    const { location, requestLocation, declined, allowLocationAccess, isLocationServiceEnabled } = useLocationAccess()

    const _loadCitiesSuggestions = (query: string, callback: any) => {
        if (!query || query.length < 3) return callback([]);

        fetchCities(query)
            .then(resp => callback(resp.map((item: string) => ({ value: item, label: item })))).catch(() => callback([]))
    };

    const loadCitiesSuggestions = debounce(_loadCitiesSuggestions, 200);

    const getSelectedCities = () => {
        if (value) {
            return { label: value, value }
        }
    }

    const handleChange = (selected: any) => {
        onChange(selected?.value ?? '')
        updateCoordinates(coordinates)
    }


    // const fetchGeolocation = async () => {
    //     navigator.geolocation.getCurrentPosition(
    //         (pos) => setCoordinates({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
    //         (err) => {
    //             console.error(err)
    //             // setCoordinates(indiaCenter); // Fallback to India center if geolocation fails
    //         }
    //     )
    // }

    // useEffect(() => {
    //     fetchGeolocation();
    // }, []);

    useEffect(() => {
        requestLocation?.();
    }, [requestLocation])

    useEffect(() => {
        if (location) {
            setCoordinates(location);
        }
    }, [location])

    const fetchUserCity = async () => {
        if (!coordinates || value) return;
        const data = await fetchNearestCity(coordinates);
        if (Array.isArray(data.results)) {
            setNearbyCities(data.results.map((city: string) => ({ label: city, value: city })));
        }
    }

    useEffect(() => {
        if (!coordinates && !value) return;
        fetchUserCity();
    }, [coordinates, value])

    return (
        <div>
            <div className="profile-input position-relative">
                <label className="font-12 d-block profile-input-label">
                    City <span className="text-danger">*</span>
                </label>
                {/* <AsyncSelect isClearable noOptionsMessage={ () => 'Start Typing...' } classNamePrefix={'influns-app'} className="profile-input-form-control-wrapper" placeholder='Location' menuPlacement='top' cacheOptions loadOptions={loadCitiesSuggestions} value={getSelectedCities()} onChange={handleChange} /> */}
                <Select isClearable classNamePrefix={'influns-app'} className="profile-input-form-control-wrapper" isDisabled={declined} placeholder='Location' onMenuOpen={onMenuOpen} onMenuClose={onMenuClose} menuPlacement='bottom' menuShouldScrollIntoView options={nearbyCities} value={getSelectedCities()} onChange={handleChange} />
                {
                    !value &&
                    <div className="location-picker" onClick={allowLocationAccess}>
                        <i className="fa-solid fa-location-arrow"></i>
                    </div>
                }

            </div>
            {
                (declined || !isLocationServiceEnabled) &&
                <div className="my-2 mb-n1 w-100 text-center">
                    <span className="text-danger">Allow access to your location to show nearby cities.
                        <div className="d-flex align-items-center justify-content-center gap-2 w-100 text-primary">
                            <button className="unset-all text-primary cursor-pointer" type="button" onClick={allowLocationAccess}><i className="fa-solid fa-location-arrow"></i>
                                Allow
                                {
                                    !isNativePlatform() &&
                                    <>
                                        <Link to={`/help/location?browser=${encodeURIComponent(detectBrowser())}`} className="text-primary" target="_blank">
                                            {' '}| <i className="fa-solid fa-circle-info me-1"></i>
                                            View Help
                                        </Link>
                                    </>
                                }
                            </button>
                        </div>

                    </span>
                </div>
            }
        </div>

    )
}

export default LocationSelection